import { render, staticRenderFns } from "./ControlEditor.vue?vue&type=template&id=009fa97c&scoped=true"
import script from "./ControlEditor.vue?vue&type=script&lang=js"
export * from "./ControlEditor.vue?vue&type=script&lang=js"
import style0 from "./ControlEditor.vue?vue&type=style&index=0&id=009fa97c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "009fa97c",
  null
  
)

export default component.exports